import React from 'react';
import FormDataProvider from 'integrations/contexts/FormDataProvider';

import { SidebarProvider } from './context/Sidebar';
import { StepsProvider } from './context/Steps';
import { AdvancedOptionsProvider } from './context/AdvancedOptions';
import Defender from './Defender';
import INITIAL_FORMDATA from './_initialFormData';

const EmbeddedDefenderApp = () => (
  <StepsProvider>
    <FormDataProvider initialFormData={INITIAL_FORMDATA}>
      <SidebarProvider>
        <AdvancedOptionsProvider>
          <Defender externalInputSubmit={false} />
        </AdvancedOptionsProvider>
      </SidebarProvider>
    </FormDataProvider>
  </StepsProvider>
);

export default EmbeddedDefenderApp;
